/**
 * MapLibre GL loading shared by the map components.
 *
 * MapLibre v6 ships as ESM only and no longer inlines its worker: under a
 * bundler, `setWorkerUrl()` must point at the worker file before the first map
 * is created. The `?worker&url` import is resolved by the consuming app's Vite
 * build, which emits the worker as a self-contained chunk.
 */
/** Stylesheet of the MapLibre version declared in package.json — keep them in sync. */
export const MAPLIBRE_CSS_URL = 'https://unpkg.com/maplibre-gl@6.11.1/dist/maplibre-gl.css';
let maplibre;
export function loadMaplibre() {
    maplibre ?? (maplibre = Promise.all([
        import('maplibre-gl'),
        import('maplibre-gl/dist/maplibre-gl-worker.mjs?worker&url'),
    ]).then(([lib, worker]) => {
        // Optional call: test suites replace maplibre-gl with stubs that omit it.
        lib.setWorkerUrl?.(worker.default);
        return lib;
    }));
    return maplibre;
}
//# sourceMappingURL=maplibre.js.map